import { flatten } from "@spscommerce/utils";

export interface ISelectChildrenGroup {
    type?: any;
    props?: { [key: string]: any };
}

export function selectChildren(
    children: any = [],
    groups: Array<ISelectChildrenGroup | Array<ISelectChildrenGroup>> = [],
) {
    const childrenArray = Array.isArray(children) ? flatten(children) : [children];
    const normGroups: Array<Array<ISelectChildrenGroup>> = groups.map(s => Array.isArray(s) ? s : [s]);
    const nodeLists = (new Array(normGroups.length + 1)).fill(null).map(() => []);

    for (const node of childrenArray) {
        let nodeSelected = false;
        for (let i = 0; i < normGroups.length; i++) {
            for (const { type, props = {} } of normGroups[i]) {
                if (node.type === type) {
                    const propsMatch = Object.keys(props)
                        .every(prop => props[prop] === node.props[prop]);
                    if (propsMatch) {
                        nodeSelected = true;
                        nodeLists[i].push(node);
                        break;
                    }
                }
            }
        }
        if (!nodeSelected) {
            nodeLists[nodeLists.length - 1].push(node);
        }
    }
    return nodeLists;
}
